/**
 * This file is used to match the countries with iso2, iso3 and their primary names.
 * Note: This will be removed once our excel mapping with iso2 and country names is done
 */
export const countriesDetails = [
  {
    num_code: '4',
    alpha2Code: 'AF',
    alpha3Code: 'AFG',
    englishShortName: 'Afghanistan',
    nationality: 'Afghan',
  },
  {
    num_code: '248',
    alpha2Code: 'AX',
    alpha3Code: 'ALA',
    englishShortName: 'Aland Islands',
    nationality: 'Aland Island',
  },
  {
    num_code: '8',
    alpha2Code: 'AL',
    alpha3Code: 'ALB',
    englishShortName: 'Albania',
    nationality: 'Albanian',
  },
  {
    num_code: '12',
    alpha2Code: 'DZ',
    alpha3Code: 'DZA',
    englishShortName: 'Algeria',
    nationality: 'Algerian',
  },
  {
    num_code: '16',
    alpha2Code: 'AS',
    alpha3Code: 'ASM',
    englishShortName: 'American Samoa',
    nationality: 'American Samoan',
  },
  {
    num_code: '20',
    alpha2Code: 'AD',
    alpha3Code: 'AND',
    englishShortName: 'Andorra',
    nationality: 'Andorran',
  },
  {
    num_code: '24',
    alpha2Code: 'AO',
    alpha3Code: 'AGO',
    englishShortName: 'Angola',
    nationality: 'Angolan',
  },
  {
    num_code: '660',
    alpha2Code: 'AI',
    alpha3Code: 'AIA',
    englishShortName: 'Anguilla',
    nationality: 'Anguillan',
  },
  {
    num_code: '10',
    alpha2Code: 'AQ',
    alpha3Code: 'ATA',
    englishShortName: 'Antarctica',
    nationality: 'Antarctic',
  },
  {
    num_code: '28',
    alpha2Code: 'AG',
    alpha3Code: 'ATG',
    englishShortName: 'Antigua and Barbuda',
    nationality: 'Antiguan, Barbudan',
  },
  {
    num_code: '32',
    alpha2Code: 'AR',
    alpha3Code: 'ARG',
    englishShortName: 'Argentina',
    nationality: 'Argentine',
  },
  {
    num_code: '51',
    alpha2Code: 'AM',
    alpha3Code: 'ARM',
    englishShortName: 'Armenia',
    nationality: 'Armenian',
  },
  {
    num_code: '533',
    alpha2Code: 'AW',
    alpha3Code: 'ABW',
    englishShortName: 'Aruba',
    nationality: 'Aruban',
  },
  {
    num_code: '36',
    alpha2Code: 'AU',
    alpha3Code: 'AUS',
    englishShortName: 'Australia',
    nationality: 'Australian',
  },
  {
    num_code: '40',
    alpha2Code: 'AT',
    alpha3Code: 'AUT',
    englishShortName: 'Austria',
    nationality: 'Austrian',
  },
  {
    num_code: '31',
    alpha2Code: 'AZ',
    alpha3Code: 'AZE',
    englishShortName: 'Azerbaijan',
    nationality: 'Azerbaijani, Azeri',
  },
  {
    num_code: '44',
    alpha2Code: 'BS',
    alpha3Code: 'BHS',
    englishShortName: 'Bahamas',
    nationality: 'Bahamian',
  },
  {
    num_code: '48',
    alpha2Code: 'BH',
    alpha3Code: 'BHR',
    englishShortName: 'Bahrain',
    nationality: 'Bahraini',
  },
  {
    num_code: '50',
    alpha2Code: 'BD',
    alpha3Code: 'BGD',
    englishShortName: 'Bangladesh',
    nationality: 'Bangladeshi',
  },
  {
    num_code: '52',
    alpha2Code: 'BB',
    alpha3Code: 'BRB',
    englishShortName: 'Barbados',
    nationality: 'Barbadian',
  },
  {
    num_code: '112',
    alpha2Code: 'BY',
    alpha3Code: 'BLR',
    englishShortName: 'Belarus',
    nationality: 'Belarusian',
  },
  {
    num_code: '56',
    alpha2Code: 'BE',
    alpha3Code: 'BEL',
    englishShortName: 'Belgium',
    nationality: 'Belgian',
  },
  {
    num_code: '84',
    alpha2Code: 'BZ',
    alpha3Code: 'BLZ',
    englishShortName: 'Belize',
    nationality: 'Belizean',
  },
  {
    num_code: '204',
    alpha2Code: 'BJ',
    alpha3Code: 'BEN',
    englishShortName: 'Benin',
    nationality: 'Beninese, Beninois',
  },
  {
    num_code: '60',
    alpha2Code: 'BM',
    alpha3Code: 'BMU',
    englishShortName: 'Bermuda',
    nationality: 'Bermudian, Bermudan',
  },
  {
    num_code: '64',
    alpha2Code: 'BT',
    alpha3Code: 'BTN',
    englishShortName: 'Bhutan',
    nationality: 'Bhutanese',
  },
  {
    num_code: '68',
    alpha2Code: 'BO',
    alpha3Code: 'BOL',
    englishShortName: 'Bolivia (Plurinational State of)',
    nationality: 'Bolivian',
  },
  {
    num_code: '535',
    alpha2Code: 'BQ',
    alpha3Code: 'BES',
    englishShortName: 'Bonaire, Sint Eustatius and Saba',
    nationality: 'Bonaire',
  },
  {
    num_code: '70',
    alpha2Code: 'BA',
    alpha3Code: 'BIH',
    englishShortName: 'Bosnia and Herzegovina',
    nationality: 'Bosnian, Herzegovinian',
  },
  {
    num_code: '72',
    alpha2Code: 'BW',
    alpha3Code: 'BWA',
    englishShortName: 'Botswana',
    nationality: 'Motswana, Botswanan',
  },
  {
    num_code: '74',
    alpha2Code: 'BV',
    alpha3Code: 'BVT',
    englishShortName: 'Bouvet Island',
    nationality: 'Bouvet Island',
  },
  {
    num_code: '76',
    alpha2Code: 'BR',
    alpha3Code: 'BRA',
    englishShortName: 'Brazil',
    nationality: 'Brazilian',
  },
  {
    num_code: '86',
    alpha2Code: 'IO',
    alpha3Code: 'IOT',
    englishShortName: 'British Indian Ocean Territory',
    nationality: 'BIOT',
  },
  {
    num_code: '96',
    alpha2Code: 'BN',
    alpha3Code: 'BRN',
    englishShortName: 'Brunei Darussalam',
    nationality: 'Bruneian',
  },
  {
    num_code: '100',
    alpha2Code: 'BG',
    alpha3Code: 'BGR',
    englishShortName: 'Bulgaria',
    nationality: 'Bulgarian',
  },
  {
    num_code: '854',
    alpha2Code: 'BF',
    alpha3Code: 'BFA',
    englishShortName: 'Burkina Faso',
    nationality: 'Burkinab\u00e9',
  },
  {
    num_code: '108',
    alpha2Code: 'BI',
    alpha3Code: 'BDI',
    englishShortName: 'Burundi',
    nationality: 'Burundian',
  },
  {
    num_code: '132',
    alpha2Code: 'CV',
    alpha3Code: 'CPV',
    englishShortName: 'Cabo Verde',
    nationality: 'Cabo Verdean',
  },
  {
    num_code: '116',
    alpha2Code: 'KH',
    alpha3Code: 'KHM',
    englishShortName: 'Cambodia',
    nationality: 'Cambodian',
  },
  {
    num_code: '120',
    alpha2Code: 'CM',
    alpha3Code: 'CMR',
    englishShortName: 'Cameroon',
    nationality: 'Cameroonian',
  },
  {
    num_code: '124',
    alpha2Code: 'CA',
    alpha3Code: 'CAN',
    englishShortName: 'Canada',
    nationality: 'Canadian',
  },
  {
    num_code: '136',
    alpha2Code: 'KY',
    alpha3Code: 'CYM',
    englishShortName: 'Cayman Islands',
    nationality: 'Caymanian',
  },
  {
    num_code: '140',
    alpha2Code: 'CF',
    alpha3Code: 'CAF',
    englishShortName: 'Central African Republic',
    nationality: 'Central African',
  },
  {
    num_code: '148',
    alpha2Code: 'TD',
    alpha3Code: 'TCD',
    englishShortName: 'Chad',
    nationality: 'Chadian',
  },
  {
    num_code: '152',
    alpha2Code: 'CL',
    alpha3Code: 'CHL',
    englishShortName: 'Chile',
    nationality: 'Chilean',
  },
  {
    num_code: '156',
    alpha2Code: 'CN',
    alpha3Code: 'CHN',
    englishShortName: 'China',
    nationality: 'Chinese',
  },
  {
    num_code: '162',
    alpha2Code: 'CX',
    alpha3Code: 'CXR',
    englishShortName: 'Christmas Island',
    nationality: 'Christmas Island',
  },
  {
    num_code: '166',
    alpha2Code: 'CC',
    alpha3Code: 'CCK',
    englishShortName: 'Cocos (Keeling) Islands',
    nationality: 'Cocos Island',
  },
  {
    num_code: '170',
    alpha2Code: 'CO',
    alpha3Code: 'COL',
    englishShortName: 'Colombia',
    nationality: 'Colombian',
  },
  {
    num_code: '174',
    alpha2Code: 'KM',
    alpha3Code: 'COM',
    englishShortName: 'Comoros',
    nationality: 'Comoran, Comorian',
  },
  {
    num_code: '178',
    alpha2Code: 'CG',
    alpha3Code: 'COG',
    englishShortName: 'Congo (Republic of the)',
    nationality: 'Congolese',
  },
  {
    num_code: '180',
    alpha2Code: 'CD',
    alpha3Code: 'COD',
    englishShortName: 'Congo (Democratic Republic of the)',
    nationality: 'Congolese',
  },
  {
    num_code: '184',
    alpha2Code: 'CK',
    alpha3Code: 'COK',
    englishShortName: 'Cook Islands',
    nationality: 'Cook Island',
  },
  {
    num_code: '188',
    alpha2Code: 'CR',
    alpha3Code: 'CRI',
    englishShortName: 'Costa Rica',
    nationality: 'Costa Rican',
  },
  {
    num_code: '384',
    alpha2Code: 'CI',
    alpha3Code: 'CIV',
    englishShortName: "Cote d'Ivoire",
    nationality: 'Ivorian',
  },
  {
    num_code: '191',
    alpha2Code: 'HR',
    alpha3Code: 'HRV',
    englishShortName: 'Croatia',
    nationality: 'Croatian',
  },
  {
    num_code: '192',
    alpha2Code: 'CU',
    alpha3Code: 'CUB',
    englishShortName: 'Cuba',
    nationality: 'Cuban',
  },
  {
    num_code: '531',
    alpha2Code: 'CW',
    alpha3Code: 'CUW',
    englishShortName: 'Curaçao',
    nationality: 'Cura\u00e7aoan',
  },
  {
    num_code: '196',
    alpha2Code: 'CY',
    alpha3Code: 'CYP',
    englishShortName: 'Cyprus',
    nationality: 'Cypriot',
  },
  {
    num_code: '203',
    alpha2Code: 'CZ',
    alpha3Code: 'CZE',
    englishShortName: 'Czech Republic',
    nationality: 'Czech',
  },
  {
    num_code: '208',
    alpha2Code: 'DK',
    alpha3Code: 'DNK',
    englishShortName: 'Denmark',
    nationality: 'Danish',
  },
  {
    num_code: '262',
    alpha2Code: 'DJ',
    alpha3Code: 'DJI',
    englishShortName: 'Djibouti',
    nationality: 'Djiboutian',
  },
  {
    num_code: '212',
    alpha2Code: 'DM',
    alpha3Code: 'DMA',
    englishShortName: 'Dominica',
    nationality: 'Dominican',
  },
  {
    num_code: '214',
    alpha2Code: 'DO',
    alpha3Code: 'DOM',
    englishShortName: 'Dominican Republic',
    nationality: 'Dominican',
  },
  {
    num_code: '218',
    alpha2Code: 'EC',
    alpha3Code: 'ECU',
    englishShortName: 'Ecuador',
    nationality: 'Ecuadorian',
  },
  {
    num_code: '818',
    alpha2Code: 'EG',
    alpha3Code: 'EGY',
    englishShortName: 'Egypt',
    nationality: 'Egyptian',
  },
  {
    num_code: '222',
    alpha2Code: 'SV',
    alpha3Code: 'SLV',
    englishShortName: 'El Salvador',
    nationality: 'Salvadoran',
  },
  {
    num_code: '226',
    alpha2Code: 'GQ',
    alpha3Code: 'GNQ',
    englishShortName: 'Equatorial Guinea',
    nationality: 'Equatorial Guinean, Equatoguinean',
  },
  {
    num_code: '232',
    alpha2Code: 'ER',
    alpha3Code: 'ERI',
    englishShortName: 'Eritrea',
    nationality: 'Eritrean',
  },
  {
    num_code: '233',
    alpha2Code: 'EE',
    alpha3Code: 'EST',
    englishShortName: 'Estonia',
    nationality: 'Estonian',
  },
  {
    num_code: '231',
    alpha2Code: 'ET',
    alpha3Code: 'ETH',
    englishShortName: 'Ethiopia',
    nationality: 'Ethiopian',
  },
  {
    num_code: '238',
    alpha2Code: 'FK',
    alpha3Code: 'FLK',
    englishShortName: 'Falkland Islands (Malvinas)',
    nationality: 'Falkland Island',
  },
  {
    num_code: '234',
    alpha2Code: 'FO',
    alpha3Code: 'FRO',
    englishShortName: 'Faroe Islands',
    nationality: 'Faroese',
  },
  {
    num_code: '242',
    alpha2Code: 'FJ',
    alpha3Code: 'FJI',
    englishShortName: 'Fiji',
    nationality: 'Fijian',
  },
  {
    num_code: '246',
    alpha2Code: 'FI',
    alpha3Code: 'FIN',
    englishShortName: 'Finland',
    nationality: 'Finnish',
  },
  {
    num_code: '250',
    alpha2Code: 'FR',
    alpha3Code: 'FRA',
    englishShortName: 'France',
    nationality: 'French',
  },
  {
    num_code: '254',
    alpha2Code: 'GF',
    alpha3Code: 'GUF',
    englishShortName: 'French Guiana',
    nationality: 'French Guianese',
  },
  {
    num_code: '258',
    alpha2Code: 'PF',
    alpha3Code: 'PYF',
    englishShortName: 'French Polynesia',
    nationality: 'French Polynesian',
  },
  {
    num_code: '260',
    alpha2Code: 'TF',
    alpha3Code: 'ATF',
    englishShortName: 'French Southern Territories',
    nationality: 'French Southern Territories',
  },
  {
    num_code: '266',
    alpha2Code: 'GA',
    alpha3Code: 'GAB',
    englishShortName: 'Gabon',
    nationality: 'Gabonese',
  },
  {
    num_code: '270',
    alpha2Code: 'GM',
    alpha3Code: 'GMB',
    englishShortName: 'Gambia',
    nationality: 'Gambian',
  },
  {
    num_code: '268',
    alpha2Code: 'GE',
    alpha3Code: 'GEO',
    englishShortName: 'Georgia',
    nationality: 'Georgian',
  },
  {
    num_code: '276',
    alpha2Code: 'DE',
    alpha3Code: 'DEU',
    englishShortName: 'Germany',
    nationality: 'German',
  },
  {
    num_code: '288',
    alpha2Code: 'GH',
    alpha3Code: 'GHA',
    englishShortName: 'Ghana',
    nationality: 'Ghanaian',
  },
  {
    num_code: '292',
    alpha2Code: 'GI',
    alpha3Code: 'GIB',
    englishShortName: 'Gibraltar',
    nationality: 'Gibraltar',
  },
  {
    num_code: '300',
    alpha2Code: 'GR',
    alpha3Code: 'GRC',
    englishShortName: 'Greece',
    nationality: 'Greek, Hellenic',
  },
  {
    num_code: '304',
    alpha2Code: 'GL',
    alpha3Code: 'GRL',
    englishShortName: 'Greenland',
    nationality: 'Greenlandic',
  },
  {
    num_code: '308',
    alpha2Code: 'GD',
    alpha3Code: 'GRD',
    englishShortName: 'Grenada',
    nationality: 'Grenadian',
  },
  {
    num_code: '312',
    alpha2Code: 'GP',
    alpha3Code: 'GLP',
    englishShortName: 'Guadeloupe',
    nationality: 'Guadeloupe',
  },
  {
    num_code: '316',
    alpha2Code: 'GU',
    alpha3Code: 'GUM',
    englishShortName: 'Guam',
    nationality: 'Guamanian, Guambat',
  },
  {
    num_code: '320',
    alpha2Code: 'GT',
    alpha3Code: 'GTM',
    englishShortName: 'Guatemala',
    nationality: 'Guatemalan',
  },
  {
    num_code: '831',
    alpha2Code: 'GG',
    alpha3Code: 'GGY',
    englishShortName: 'Guernsey',
    nationality: 'Channel Island',
  },
  {
    num_code: '324',
    alpha2Code: 'GN',
    alpha3Code: 'GIN',
    englishShortName: 'Guinea',
    nationality: 'Guinean',
  },
  {
    num_code: '624',
    alpha2Code: 'GW',
    alpha3Code: 'GNB',
    englishShortName: 'Guinea-Bissau',
    nationality: 'Bissau-Guinean',
  },
  {
    num_code: '328',
    alpha2Code: 'GY',
    alpha3Code: 'GUY',
    englishShortName: 'Guyana',
    nationality: 'Guyanese',
  },
  {
    num_code: '332',
    alpha2Code: 'HT',
    alpha3Code: 'HTI',
    englishShortName: 'Haiti',
    nationality: 'Haitian',
  },
  {
    num_code: '334',
    alpha2Code: 'HM',
    alpha3Code: 'HMD',
    englishShortName: 'Heard Island and McDonald Islands',
    nationality: 'Heard Island, McDonald Islands',
  },
  {
    num_code: '336',
    alpha2Code: 'VA',
    alpha3Code: 'VAT',
    englishShortName: 'Vatican City State',
    nationality: 'Vatican',
  },
  {
    num_code: '340',
    alpha2Code: 'HN',
    alpha3Code: 'HND',
    englishShortName: 'Honduras',
    nationality: 'Honduran',
  },
  {
    num_code: '344',
    alpha2Code: 'HK',
    alpha3Code: 'HKG',
    englishShortName: 'Hong Kong',
    nationality: 'Hong Kong, Hong Kongese',
  },
  {
    num_code: '348',
    alpha2Code: 'HU',
    alpha3Code: 'HUN',
    englishShortName: 'Hungary',
    nationality: 'Hungarian, Magyar',
  },
  {
    num_code: '352',
    alpha2Code: 'IS',
    alpha3Code: 'ISL',
    englishShortName: 'Iceland',
    nationality: 'Icelandic',
  },
  {
    num_code: '356',
    alpha2Code: 'IN',
    alpha3Code: 'IND',
    englishShortName: 'India',
    nationality: 'Indian',
  },
  {
    num_code: '360',
    alpha2Code: 'ID',
    alpha3Code: 'IDN',
    englishShortName: 'Indonesia',
    nationality: 'Indonesian',
  },
  {
    num_code: '364',
    alpha2Code: 'IR',
    alpha3Code: 'IRN',
    englishShortName: 'Iran',
    nationality: 'Iranian, Persian',
  },
  {
    num_code: '368',
    alpha2Code: 'IQ',
    alpha3Code: 'IRQ',
    englishShortName: 'Iraq',
    nationality: 'Iraqi',
  },
  {
    num_code: '372',
    alpha2Code: 'IE',
    alpha3Code: 'IRL',
    englishShortName: 'Ireland',
    nationality: 'Irish',
  },
  {
    num_code: '833',
    alpha2Code: 'IM',
    alpha3Code: 'IMN',
    englishShortName: 'Isle of Man',
    nationality: 'Manx',
  },
  {
    num_code: '376',
    alpha2Code: 'IL',
    alpha3Code: 'ISR',
    englishShortName: 'Israel',
    nationality: 'Israeli',
  },
  {
    num_code: '380',
    alpha2Code: 'IT',
    alpha3Code: 'ITA',
    englishShortName: 'Italy',
    nationality: 'Italian',
  },
  {
    num_code: '388',
    alpha2Code: 'JM',
    alpha3Code: 'JAM',
    englishShortName: 'Jamaica',
    nationality: 'Jamaican',
  },
  {
    num_code: '392',
    alpha2Code: 'JP',
    alpha3Code: 'JPN',
    englishShortName: 'Japan',
    nationality: 'Japanese',
  },
  {
    num_code: '832',
    alpha2Code: 'JE',
    alpha3Code: 'JEY',
    englishShortName: 'Jersey',
    nationality: 'Channel Island',
  },
  {
    num_code: '400',
    alpha2Code: 'JO',
    alpha3Code: 'JOR',
    englishShortName: 'Jordan',
    nationality: 'Jordanian',
  },
  {
    num_code: '398',
    alpha2Code: 'KZ',
    alpha3Code: 'KAZ',
    englishShortName: 'Kazakhstan',
    nationality: 'Kazakhstani, Kazakh',
  },
  {
    num_code: '404',
    alpha2Code: 'KE',
    alpha3Code: 'KEN',
    englishShortName: 'Kenya',
    nationality: 'Kenyan',
  },
  {
    num_code: '296',
    alpha2Code: 'KI',
    alpha3Code: 'KIR',
    englishShortName: 'Kiribati',
    nationality: 'I-Kiribati',
  },
  {
    num_code: '408',
    alpha2Code: 'KP',
    alpha3Code: 'PRK',
    englishShortName: "Korea (Democratic People's Republic of)",
    nationality: 'North Korean',
  },
  {
    num_code: '410',
    alpha2Code: 'KR',
    alpha3Code: 'KOR',
    englishShortName: 'Korea (Republic of)',
    nationality: 'South Korean',
  },
  {
    num_code: '414',
    alpha2Code: 'KW',
    alpha3Code: 'KWT',
    englishShortName: 'Kuwait',
    nationality: 'Kuwaiti',
  },
  {
    num_code: '417',
    alpha2Code: 'KG',
    alpha3Code: 'KGZ',
    englishShortName: 'Kyrgyzstan',
    nationality: 'Kyrgyzstani, Kyrgyz, Kirgiz, Kirghiz',
  },
  {
    num_code: '418',
    alpha2Code: 'LA',
    alpha3Code: 'LAO',
    englishShortName: "Lao People's Democratic Republic",
    nationality: 'Lao, Laotian',
  },
  {
    num_code: '428',
    alpha2Code: 'LV',
    alpha3Code: 'LVA',
    englishShortName: 'Latvia',
    nationality: 'Latvian',
  },
  {
    num_code: '422',
    alpha2Code: 'LB',
    alpha3Code: 'LBN',
    englishShortName: 'Lebanon',
    nationality: 'Lebanese',
  },
  {
    num_code: '426',
    alpha2Code: 'LS',
    alpha3Code: 'LSO',
    englishShortName: 'Lesotho',
    nationality: 'Basotho',
  },
  {
    num_code: '430',
    alpha2Code: 'LR',
    alpha3Code: 'LBR',
    englishShortName: 'Liberia',
    nationality: 'Liberian',
  },
  {
    num_code: '434',
    alpha2Code: 'LY',
    alpha3Code: 'LBY',
    englishShortName: 'Libya',
    nationality: 'Libyan',
  },
  {
    num_code: '438',
    alpha2Code: 'LI',
    alpha3Code: 'LIE',
    englishShortName: 'Liechtenstein',
    nationality: 'Liechtenstein',
  },
  {
    num_code: '440',
    alpha2Code: 'LT',
    alpha3Code: 'LTU',
    englishShortName: 'Lithuania',
    nationality: 'Lithuanian',
  },
  {
    num_code: '442',
    alpha2Code: 'LU',
    alpha3Code: 'LUX',
    englishShortName: 'Luxembourg',
    nationality: 'Luxembourg, Luxembourgish',
  },
  {
    num_code: '446',
    alpha2Code: 'MO',
    alpha3Code: 'MAC',
    englishShortName: 'Macao',
    nationality: 'Macanese, Chinese',
  },
  {
    num_code: '807',
    alpha2Code: 'MK',
    alpha3Code: 'MKD',
    englishShortName: 'Macedonia (the former Yugoslav Republic of)',
    nationality: 'Macedonian',
  },
  {
    num_code: '450',
    alpha2Code: 'MG',
    alpha3Code: 'MDG',
    englishShortName: 'Madagascar',
    nationality: 'Malagasy',
  },
  {
    num_code: '454',
    alpha2Code: 'MW',
    alpha3Code: 'MWI',
    englishShortName: 'Malawi',
    nationality: 'Malawian',
  },
  {
    num_code: '458',
    alpha2Code: 'MY',
    alpha3Code: 'MYS',
    englishShortName: 'Malaysia',
    nationality: 'Malaysian',
  },
  {
    num_code: '462',
    alpha2Code: 'MV',
    alpha3Code: 'MDV',
    englishShortName: 'Maldives',
    nationality: 'Maldivian',
  },
  {
    num_code: '466',
    alpha2Code: 'ML',
    alpha3Code: 'MLI',
    englishShortName: 'Mali',
    nationality: 'Malian, Malinese',
  },
  {
    num_code: '470',
    alpha2Code: 'MT',
    alpha3Code: 'MLT',
    englishShortName: 'Malta',
    nationality: 'Maltese',
  },
  {
    num_code: '584',
    alpha2Code: 'MH',
    alpha3Code: 'MHL',
    englishShortName: 'Marshall Islands',
    nationality: 'Marshallese',
  },
  {
    num_code: '474',
    alpha2Code: 'MQ',
    alpha3Code: 'MTQ',
    englishShortName: 'Martinique',
    nationality: 'Martiniquais, Martinican',
  },
  {
    num_code: '478',
    alpha2Code: 'MR',
    alpha3Code: 'MRT',
    englishShortName: 'Mauritania',
    nationality: 'Mauritanian',
  },
  {
    num_code: '480',
    alpha2Code: 'MU',
    alpha3Code: 'MUS',
    englishShortName: 'Mauritius',
    nationality: 'Mauritian',
  },
  {
    num_code: '175',
    alpha2Code: 'YT',
    alpha3Code: 'MYT',
    englishShortName: 'Mayotte',
    nationality: 'Mahoran',
  },
  {
    num_code: '484',
    alpha2Code: 'MX',
    alpha3Code: 'MEX',
    englishShortName: 'Mexico',
    nationality: 'Mexican',
  },
  {
    num_code: '583',
    alpha2Code: 'FM',
    alpha3Code: 'FSM',
    englishShortName: 'Micronesia (Federated States of)',
    nationality: 'Micronesian',
  },
  {
    num_code: '498',
    alpha2Code: 'MD',
    alpha3Code: 'MDA',
    englishShortName: 'Moldova (Republic of)',
    nationality: 'Moldovan',
  },
  {
    num_code: '492',
    alpha2Code: 'MC',
    alpha3Code: 'MCO',
    englishShortName: 'Monaco',
    nationality: 'Monegasque, Monacan',
  },
  {
    num_code: '496',
    alpha2Code: 'MN',
    alpha3Code: 'MNG',
    englishShortName: 'Mongolia',
    nationality: 'Mongolian',
  },
  {
    num_code: '499',
    alpha2Code: 'ME',
    alpha3Code: 'MNE',
    englishShortName: 'Montenegro',
    nationality: 'Montenegrin',
  },
  {
    num_code: '500',
    alpha2Code: 'MS',
    alpha3Code: 'MSR',
    englishShortName: 'Montserrat',
    nationality: 'Montserratian',
  },
  {
    num_code: '504',
    alpha2Code: 'MA',
    alpha3Code: 'MAR',
    englishShortName: 'Morocco',
    nationality: 'Moroccan',
  },
  {
    num_code: '508',
    alpha2Code: 'MZ',
    alpha3Code: 'MOZ',
    englishShortName: 'Mozambique',
    nationality: 'Mozambican',
  },
  {
    num_code: '104',
    alpha2Code: 'MM',
    alpha3Code: 'MMR',
    englishShortName: 'Myanmar',
    nationality: 'Burmese',
  },
  {
    num_code: '516',
    alpha2Code: 'NA',
    alpha3Code: 'NAM',
    englishShortName: 'Namibia',
    nationality: 'Namibian',
  },
  {
    num_code: '520',
    alpha2Code: 'NR',
    alpha3Code: 'NRU',
    englishShortName: 'Nauru',
    nationality: 'Nauruan',
  },
  {
    num_code: '524',
    alpha2Code: 'NP',
    alpha3Code: 'NPL',
    englishShortName: 'Nepal',
    nationality: 'Nepali, Nepalese',
  },
  {
    num_code: '528',
    alpha2Code: 'NL',
    alpha3Code: 'NLD',
    englishShortName: 'Netherlands',
    nationality: 'Dutch, Netherlandic',
  },
  {
    num_code: '540',
    alpha2Code: 'NC',
    alpha3Code: 'NCL',
    englishShortName: 'New Caledonia',
    nationality: 'New Caledonian',
  },
  {
    num_code: '554',
    alpha2Code: 'NZ',
    alpha3Code: 'NZL',
    englishShortName: 'New Zealand',
    nationality: 'New Zealand, NZ',
  },
  {
    num_code: '558',
    alpha2Code: 'NI',
    alpha3Code: 'NIC',
    englishShortName: 'Nicaragua',
    nationality: 'Nicaraguan',
  },
  {
    num_code: '562',
    alpha2Code: 'NE',
    alpha3Code: 'NER',
    englishShortName: 'Niger',
    nationality: 'Nigerien',
  },
  {
    num_code: '566',
    alpha2Code: 'NG',
    alpha3Code: 'NGA',
    englishShortName: 'Nigeria',
    nationality: 'Nigerian',
  },
  {
    num_code: '570',
    alpha2Code: 'NU',
    alpha3Code: 'NIU',
    englishShortName: 'Niue',
    nationality: 'Niuean',
  },
  {
    num_code: '574',
    alpha2Code: 'NF',
    alpha3Code: 'NFK',
    englishShortName: 'Norfolk Island',
    nationality: 'Norfolk Island',
  },
  {
    num_code: '580',
    alpha2Code: 'MP',
    alpha3Code: 'MNP',
    englishShortName: 'Northern Mariana Islands',
    nationality: 'Northern Marianan',
  },
  {
    num_code: '578',
    alpha2Code: 'NO',
    alpha3Code: 'NOR',
    englishShortName: 'Norway',
    nationality: 'Norwegian',
  },
  {
    num_code: '512',
    alpha2Code: 'OM',
    alpha3Code: 'OMN',
    englishShortName: 'Oman',
    nationality: 'Omani',
  },
  {
    num_code: '586',
    alpha2Code: 'PK',
    alpha3Code: 'PAK',
    englishShortName: 'Pakistan',
    nationality: 'Pakistani',
  },
  {
    num_code: '585',
    alpha2Code: 'PW',
    alpha3Code: 'PLW',
    englishShortName: 'Palau',
    nationality: 'Palauan',
  },
  {
    num_code: '275',
    alpha2Code: 'PS',
    alpha3Code: 'PSE',
    englishShortName: 'Palestine, State of',
    nationality: 'Palestinian',
  },
  {
    num_code: '591',
    alpha2Code: 'PA',
    alpha3Code: 'PAN',
    englishShortName: 'Panama',
    nationality: 'Panamanian',
  },
  {
    num_code: '598',
    alpha2Code: 'PG',
    alpha3Code: 'PNG',
    englishShortName: 'Papua New Guinea',
    nationality: 'Papua New Guinean, Papuan',
  },
  {
    num_code: '600',
    alpha2Code: 'PY',
    alpha3Code: 'PRY',
    englishShortName: 'Paraguay',
    nationality: 'Paraguayan',
  },
  {
    num_code: '604',
    alpha2Code: 'PE',
    alpha3Code: 'PER',
    englishShortName: 'Peru',
    nationality: 'Peruvian',
  },
  {
    num_code: '608',
    alpha2Code: 'PH',
    alpha3Code: 'PHL',
    englishShortName: 'Philippines',
    nationality: 'Philippine, Filipino',
  },
  {
    num_code: '612',
    alpha2Code: 'PN',
    alpha3Code: 'PCN',
    englishShortName: 'Pitcairn',
    nationality: 'Pitcairn Island',
  },
  {
    num_code: '616',
    alpha2Code: 'PL',
    alpha3Code: 'POL',
    englishShortName: 'Poland',
    nationality: 'Polish',
  },
  {
    num_code: '620',
    alpha2Code: 'PT',
    alpha3Code: 'PRT',
    englishShortName: 'Portugal',
    nationality: 'Portuguese',
  },
  {
    num_code: '630',
    alpha2Code: 'PR',
    alpha3Code: 'PRI',
    englishShortName: 'Puerto Rico',
    nationality: 'Puerto Rican',
  },
  {
    num_code: '634',
    alpha2Code: 'QA',
    alpha3Code: 'QAT',
    englishShortName: 'Qatar',
    nationality: 'Qatari',
  },
  {
    num_code: '638',
    alpha2Code: 'RE',
    alpha3Code: 'REU',
    englishShortName: 'Reunion',
    nationality: 'Reunionese, Reunionnais',
  },
  {
    num_code: '642',
    alpha2Code: 'RO',
    alpha3Code: 'ROU',
    englishShortName: 'Romania',
    nationality: 'Romanian',
  },
  {
    num_code: '643',
    alpha2Code: 'RU',
    alpha3Code: 'RUS',
    englishShortName: 'Russian Federation',
    nationality: 'Russian',
  },
  {
    num_code: '646',
    alpha2Code: 'RW',
    alpha3Code: 'RWA',
    englishShortName: 'Rwanda',
    nationality: 'Rwandan',
  },
  {
    num_code: '652',
    alpha2Code: 'BL',
    alpha3Code: 'BLM',
    englishShortName: 'Saint Barthélemy',
    nationality: 'Barthelemois',
  },
  {
    num_code: '654',
    alpha2Code: 'SH',
    alpha3Code: 'SHN',
    englishShortName: 'Saint Helena, Ascension and Tristan da Cunha',
    nationality: 'Saint Helenian',
  },
  {
    num_code: '659',
    alpha2Code: 'KN',
    alpha3Code: 'KNA',
    englishShortName: 'Saint Kitts and Nevis',
    nationality: 'Kittitian, Nevisian',
  },
  {
    num_code: '662',
    alpha2Code: 'LC',
    alpha3Code: 'LCA',
    englishShortName: 'Saint Lucia',
    nationality: 'Saint Lucian',
  },
  {
    num_code: '663',
    alpha2Code: 'MF',
    alpha3Code: 'MAF',
    englishShortName: 'Saint Martin (French part)',
    nationality: 'Saint-Martinoise',
  },
  {
    num_code: '666',
    alpha2Code: 'PM',
    alpha3Code: 'SPM',
    englishShortName: 'Saint Pierre and Miquelon',
    nationality: 'Saint-Pierrais, Miquelonnais',
  },
  {
    num_code: '670',
    alpha2Code: 'VC',
    alpha3Code: 'VCT',
    englishShortName: 'Saint Vincent and the Grenadines',
    nationality: 'Saint Vincentian, Vincentian',
  },
  {
    num_code: '882',
    alpha2Code: 'WS',
    alpha3Code: 'WSM',
    englishShortName: 'Samoa',
    nationality: 'Samoan',
  },
  {
    num_code: '674',
    alpha2Code: 'SM',
    alpha3Code: 'SMR',
    englishShortName: 'San Marino',
    nationality: 'Sammarinese',
  },
  {
    num_code: '678',
    alpha2Code: 'ST',
    alpha3Code: 'STP',
    englishShortName: 'Sao Tome and Principe',
    nationality: 'Sao Tomean',
  },
  {
    num_code: '682',
    alpha2Code: 'SA',
    alpha3Code: 'SAU',
    englishShortName: 'Saudi Arabia',
    nationality: 'Saudi, Saudi Arabian',
  },
  {
    num_code: '686',
    alpha2Code: 'SN',
    alpha3Code: 'SEN',
    englishShortName: 'Senegal',
    nationality: 'Senegalese',
  },
  {
    num_code: '688',
    alpha2Code: 'RS',
    alpha3Code: 'SRB',
    englishShortName: 'Serbia',
    nationality: 'Serbian',
  },
  {
    num_code: '690',
    alpha2Code: 'SC',
    alpha3Code: 'SYC',
    englishShortName: 'Seychelles',
    nationality: 'Seychellois',
  },
  {
    num_code: '694',
    alpha2Code: 'SL',
    alpha3Code: 'SLE',
    englishShortName: 'Sierra Leone',
    nationality: 'Sierra Leonean',
  },
  {
    num_code: '702',
    alpha2Code: 'SG',
    alpha3Code: 'SGP',
    englishShortName: 'Singapore',
    nationality: 'Singaporean',
  },
  {
    num_code: '534',
    alpha2Code: 'SX',
    alpha3Code: 'SXM',
    englishShortName: 'Sint Maarten (Dutch part)',
    nationality: 'Sint Maarten',
  },
  {
    num_code: '703',
    alpha2Code: 'SK',
    alpha3Code: 'SVK',
    englishShortName: 'Slovakia',
    nationality: 'Slovak',
  },
  {
    num_code: '705',
    alpha2Code: 'SI',
    alpha3Code: 'SVN',
    englishShortName: 'Slovenia',
    nationality: 'Slovenian, Slovene',
  },
  {
    num_code: '90',
    alpha2Code: 'SB',
    alpha3Code: 'SLB',
    englishShortName: 'Solomon Islands',
    nationality: 'Solomon Island',
  },
  {
    num_code: '706',
    alpha2Code: 'SO',
    alpha3Code: 'SOM',
    englishShortName: 'Somalia',
    nationality: 'Somali, Somalian',
  },
  {
    num_code: '710',
    alpha2Code: 'ZA',
    alpha3Code: 'ZAF',
    englishShortName: 'South Africa',
    nationality: 'South African',
  },
  {
    num_code: '239',
    alpha2Code: 'GS',
    alpha3Code: 'SGS',
    englishShortName: 'South Georgia and the South Sandwich Islands',
    nationality: 'South Georgia, South Sandwich Islands',
  },
  {
    num_code: '728',
    alpha2Code: 'SS',
    alpha3Code: 'SSD',
    englishShortName: 'South Sudan',
    nationality: 'South Sudanese',
  },
  {
    num_code: '724',
    alpha2Code: 'ES',
    alpha3Code: 'ESP',
    englishShortName: 'Spain',
    nationality: 'Spanish',
  },
  {
    num_code: '144',
    alpha2Code: 'LK',
    alpha3Code: 'LKA',
    englishShortName: 'Sri Lanka',
    nationality: 'Sri Lankan',
  },
  {
    num_code: '729',
    alpha2Code: 'SD',
    alpha3Code: 'SDN',
    englishShortName: 'Sudan',
    nationality: 'Sudanese',
  },
  {
    num_code: '740',
    alpha2Code: 'SR',
    alpha3Code: 'SUR',
    englishShortName: 'Suriname',
    nationality: 'Surinamese',
  },
  {
    num_code: '744',
    alpha2Code: 'SJ',
    alpha3Code: 'SJM',
    englishShortName: 'Svalbard and Jan Mayen',
    nationality: 'Svalbard',
  },
  {
    num_code: '748',
    alpha2Code: 'SZ',
    alpha3Code: 'SWZ',
    englishShortName: 'Swaziland',
    nationality: 'Swazi',
  },
  {
    num_code: '752',
    alpha2Code: 'SE',
    alpha3Code: 'SWE',
    englishShortName: 'Sweden',
    nationality: 'Swedish',
  },
  {
    num_code: '756',
    alpha2Code: 'CH',
    alpha3Code: 'CHE',
    englishShortName: 'Switzerland',
    nationality: 'Swiss',
  },
  {
    num_code: '760',
    alpha2Code: 'SY',
    alpha3Code: 'SYR',
    englishShortName: 'Syrian Arab Republic',
    nationality: 'Syrian',
  },
  {
    num_code: '158',
    alpha2Code: 'TW',
    alpha3Code: 'TWN',
    englishShortName: 'Taiwan, Province of China',
    nationality: 'Chinese, Taiwanese',
  },
  {
    num_code: '762',
    alpha2Code: 'TJ',
    alpha3Code: 'TJK',
    englishShortName: 'Tajikistan',
    nationality: 'Tajikistani',
  },
  {
    num_code: '834',
    alpha2Code: 'TZ',
    alpha3Code: 'TZA',
    englishShortName: 'Tanzania, United Republic of',
    nationality: 'Tanzanian',
  },
  {
    num_code: '764',
    alpha2Code: 'TH',
    alpha3Code: 'THA',
    englishShortName: 'Thailand',
    nationality: 'Thai',
  },
  {
    num_code: '626',
    alpha2Code: 'TL',
    alpha3Code: 'TLS',
    englishShortName: 'Timor-Leste',
    nationality: 'Timorese',
  },
  {
    num_code: '768',
    alpha2Code: 'TG',
    alpha3Code: 'TGO',
    englishShortName: 'Togo',
    nationality: 'Togolese',
  },
  {
    num_code: '772',
    alpha2Code: 'TK',
    alpha3Code: 'TKL',
    englishShortName: 'Tokelau',
    nationality: 'Tokelauan',
  },
  {
    num_code: '776',
    alpha2Code: 'TO',
    alpha3Code: 'TON',
    englishShortName: 'Tonga',
    nationality: 'Tongan',
  },
  {
    num_code: '780',
    alpha2Code: 'TT',
    alpha3Code: 'TTO',
    englishShortName: 'Trinidad and Tobago',
    nationality: 'Trinidadian, Tobagonian',
  },
  {
    num_code: '788',
    alpha2Code: 'TN',
    alpha3Code: 'TUN',
    englishShortName: 'Tunisia',
    nationality: 'Tunisian',
  },
  {
    num_code: '792',
    alpha2Code: 'TR',
    alpha3Code: 'TUR',
    englishShortName: 'Turkey',
    nationality: 'Turkish',
  },
  {
    num_code: '795',
    alpha2Code: 'TM',
    alpha3Code: 'TKM',
    englishShortName: 'Turkmenistan',
    nationality: 'Turkmen',
  },
  {
    num_code: '796',
    alpha2Code: 'TC',
    alpha3Code: 'TCA',
    englishShortName: 'Turks and Caicos Islands',
    nationality: 'Turks and Caicos Island',
  },
  {
    num_code: '798',
    alpha2Code: 'TV',
    alpha3Code: 'TUV',
    englishShortName: 'Tuvalu',
    nationality: 'Tuvaluan',
  },
  {
    num_code: '800',
    alpha2Code: 'UG',
    alpha3Code: 'UGA',
    englishShortName: 'Uganda',
    nationality: 'Ugandan',
  },
  {
    num_code: '804',
    alpha2Code: 'UA',
    alpha3Code: 'UKR',
    englishShortName: 'Ukraine',
    nationality: 'Ukrainian',
  },
  {
    num_code: '784',
    alpha2Code: 'AE',
    alpha3Code: 'ARE',
    englishShortName: 'United Arab Emirates',
    nationality: 'Emirati, Emirian, Emiri',
  },
  {
    num_code: '826',
    alpha2Code: 'GB',
    alpha3Code: 'GBR',
    englishShortName: 'United Kingdom of Great Britain and Northern Ireland',
    nationality: 'British, UK, English',
  },
  {
    num_code: '581',
    alpha2Code: 'UM',
    alpha3Code: 'UMI',
    englishShortName: 'United States Minor Outlying Islands',
    nationality: 'American',
  },
  {
    num_code: '840',
    alpha2Code: 'US',
    alpha3Code: 'USA',
    englishShortName: 'United States of America',
    nationality: 'American',
  },
  {
    num_code: '858',
    alpha2Code: 'UY',
    alpha3Code: 'URY',
    englishShortName: 'Uruguay',
    nationality: 'Uruguayan',
  },
  {
    num_code: '860',
    alpha2Code: 'UZ',
    alpha3Code: 'UZB',
    englishShortName: 'Uzbekistan',
    nationality: 'Uzbekistani, Uzbek',
  },
  {
    num_code: '548',
    alpha2Code: 'VU',
    alpha3Code: 'VUT',
    englishShortName: 'Vanuatu',
    nationality: 'Ni-Vanuatu, Vanuatuan',
  },
  {
    num_code: '862',
    alpha2Code: 'VE',
    alpha3Code: 'VEN',
    englishShortName: 'Venezuela (Bolivarian Republic of)',
    nationality: 'Venezuelan',
  },
  {
    num_code: '704',
    alpha2Code: 'VN',
    alpha3Code: 'VNM',
    englishShortName: 'Vietnam',
    nationality: 'Vietnamese',
  },
  {
    num_code: '92',
    alpha2Code: 'VG',
    alpha3Code: 'VGB',
    englishShortName: 'Virgin Islands (British)',
    nationality: 'British Virgin Island',
  },
  {
    num_code: '850',
    alpha2Code: 'VI',
    alpha3Code: 'VIR',
    englishShortName: 'Virgin Islands (U.S.)',
    nationality: 'U.S. Virgin Island',
  },
  {
    num_code: '876',
    alpha2Code: 'WF',
    alpha3Code: 'WLF',
    englishShortName: 'Wallis and Futuna',
    nationality: 'Wallis and Futuna, Wallisian, Futunan',
  },
  {
    num_code: '732',
    alpha2Code: 'EH',
    alpha3Code: 'ESH',
    englishShortName: 'Western Sahara',
    nationality: 'Sahrawi, Sahrawian, Sahraouian',
  },
  {
    num_code: '887',
    alpha2Code: 'YE',
    alpha3Code: 'YEM',
    englishShortName: 'Yemen',
    nationality: 'Yemeni',
  },
  {
    num_code: '894',
    alpha2Code: 'ZM',
    alpha3Code: 'ZMB',
    englishShortName: 'Zambia',
    nationality: 'Zambian',
  },
  {
    num_code: '716',
    alpha2Code: 'ZW',
    alpha3Code: 'ZWE',
    englishShortName: 'Zimbabwe',
    nationality: 'Zimbabwean',
  },
];
